<template>
    <div class="float-left">
        <b-button
            variant="success"
            @click="abrirModal()"
            >Adicionar
        </b-button>
        <aplicacao-recurso-form
            operacaoProp="I"
            :aplicacaoRecurso="aplicacaoRecurso"
            :convenio = "convenio"
            :mostrarModal="mostrarModal"
            :erros="erros"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></aplicacao-recurso-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import AplicacaoRecursoForm from '../AplicacaoRecursos/AplicacaoRecursoForm.vue'

export default {
    components: {
        AplicacaoRecursoForm,
        parentData: Object,
        desativarBotao: Boolean
    },

    props: {
        convenio: Object
    },

    data() {
        return {
            mostrarModal: false,
            valor: 0,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false,
            },
            erros: [],
            naturezas: [],
            acoes: [],

            idNaturezaDespesa:null,
            aplicacaoRecurso: {
                idConvenio:0,
                idAplicacaoRecurso:0,
                idNaturezaDespesa:null,
                idAcaoConvenio:null,
                codSituacao:null,
                nuValorFinanceiroSebrae:0,
                nuValorEconomicoSebrae:0,
                nuValorFinanceiroParceiro:0,
                nuValorEconomicoParceiro:0,
                nuValorSebraeAtual: 0, 
                nuValorParceiroAtual: 0,
            },
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true;      
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(aplicacaoRecurso){
            this.$store.dispatch('addRequest')
            let convenioRecurso = {
                idConvenio : this.convenio.idConvenio,
                idAplicacaoRecurso: aplicacaoRecurso.idAplicacaoRecurso,
                idNaturezaDespesa: aplicacaoRecurso.idNaturezaDespesa,
                idAcaoConvenio: aplicacaoRecurso.idAcaoConvenio,
                codSituacao: aplicacaoRecurso.codSituacao,
                nuValorFinanceiroSebrae: aplicacaoRecurso.nuValorFinanceiroSebrae,
                nuValorEconomicoSebrae: aplicacaoRecurso.nuValorEconomicoSebrae,
                nuValorFinanceiroParceiro: aplicacaoRecurso.nuValorFinanceiroParceiro,
                nuValorEconomicoParceiro: aplicacaoRecurso.nuValorEconomicoParceiro,
                nuValorSebraeAtual: aplicacaoRecurso.nuValorFinanceiroSebrae + aplicacaoRecurso.nuValorEconomicoSebrae,
                nuValorParceiroAtual: aplicacaoRecurso.nuValorFinanceiroParceiro + aplicacaoRecurso.nuValorEconomicoParceiro,
                dtModificacaoAditivo: this.$moment(new Date(), 'DD/MM/YYYY')
            }
            ConveniosServicos.inserirAplicacaoRecurso(convenioRecurso)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Recurso Aplicado com sucesso. Para atualizar valores no RM, clicar no botão "Atualizar no RM".',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarListaAplicacaoRecurso')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
